import { render, staticRenderFns } from "./Groupbuying.vue?vue&type=template&id=0596d76d&scoped=true"
import script from "./Groupbuying.vue?vue&type=script&lang=js"
export * from "./Groupbuying.vue?vue&type=script&lang=js"
import style0 from "./Groupbuying.vue?vue&type=style&index=0&id=0596d76d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596d76d",
  null
  
)

export default component.exports